import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkboxStatusPipe'
})
export class CheckboxStatusPipePipe implements PipeTransform {

  
  transform(value: any, args?: any): any {
    console.log(args, '------------')
   let status: boolean;
   if(args.res.length >0){
     args.res.forEach(element => {
       if(element.id == args.name){
         console.log(element, args.name)
        status = true;
       }
     });
     return status;
   }
  }

}
